module.exports = __webpack_public_path__ + "img/RBT-alt.31d75dce.svg";